import { nM } from '@/legacy';
import utils from '@/resources/utils';
import bixeApi from '@/services/bixe-api.service';
import { useMeetingStore } from '@/store/pinia/meeting';

export default () => async (to, from, next) => {
  const isPrInviteFlow = to.query.flow === 'pr-invite';
  if (isPrInviteFlow) {
    next();
    return;
  }
  const meetingStore = useMeetingStore();
  const meetingId = to.query.meetingId || to.params.id;
  const pwd = to.query.pwd || false;

  if (meetingId) {
    meetingStore.updateMeetingId(meetingId);
  }

  try {
    const meeting = await bixeApi.getMeetingValidityInfo(meetingId);
    const isSafari = nM.detector.isSafari();
    const isFirefox = nM.detector.isFirefox();
    const { user, config } = window.__INITIAL_STATE__;
    const isAuthenticated = user && user.id;

    if (!isAuthenticated && meeting.pin_pass !== pwd) {
      return next('/join?reason=badLink');
    }

    if (meeting.status === 'finished') {
      return next(`/meeting-has-been-ended?id=${encodeURI(meetingId)}`);
    }

    if ((isSafari && !config.safari?.allowed) || (isFirefox && !config.firefox?.allowed)) {
      return next(`/use-app?id=${encodeURI(meetingId)}`);
    }

    utils.genericFns.saveMeetingJoinedViaDetails(meetingId, 'invite-link');
    return next();
  } catch (err) {
    if (err.error?.code === 'GuestUserAttemptedToJoinAnotherMeeting') {
      await bixeApi.attemptLogout(true);
      return next(`/joining-options?id=${encodeURI(meetingId)}&pwd=${encodeURI(pwd)}&flow=meeting-invite`);
    }
    return next('/join?reason=badLink');
  }
};
